export const getMenuIsOpen = (state) => state.menu.open
export const getFloatingMenuIsOpen = (state) => state.menu.floatingMenuOpen



// WEBPACK FOOTER //
// ./src/selectors/menu.js